import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import avatar from "assets/img/faces/marc.jpg";
import CustomTabs from "components/CustomTabs/CustomTabs";
import ToogleThings from "views/UserProfile/PageParts/ToogleThings";
import EnhancedTable from "views/Dashboard/Extra/Slideer/Tables/SortableTableFirstPage";
import { FormControl, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import SearchBox from "views/UserProfile/PageParts/SearchBox";
import Switch from '@material-ui/core/Switch';

// Icons
import Dashboard1 from "@material-ui/icons/Dashboard";
import LockIcon from "@material-ui/icons/Lock";
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import { Refresh } from "@material-ui/icons";
import PhotoSizeSelectSmallIcon from '@material-ui/icons/PhotoSizeSelectSmall';
import Binance from "../Dashboard/Extra/Slideer/Tables/Icons/Binance.png";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const useStyles = makeStyles(styles);

export default function UserProfile() {
  const classes = useStyles();


  const [FTXComponent,ToggleFTXComponent]= ToogleThings(
    <Button>It Works</Button>
  ,true)

  const [OrdersComponent,ToggleOrdersComponent] = ToogleThings(
    <GridContainer style={{background:"white", marginLeft:"10px"}} md={12} sm={12} xs={12}> 
      <GridContainer id="apiboxleftside" md={10} sm={12} xs={12}>
        <GridItem style={{marginLeft:"px"}} md={4} sm={10} xs={12}>
          <p style={{marginBottom:"1px"}}>Exchange:</p>
          <TextField variant="outlined"/>
          {/* <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="demo-simple-select-outlined-label">Demo</InputLabel>
            <Select style={{marginBottom:"10px", width:"350px",height:"40px"}}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              // value={age}
              // onChange={handleChange}
              label="Age"
            >
              <MenuItem value="">
                <em>Demo</em>
              </MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem> 
            </Select>
          </FormControl> */}

        </GridItem>

        <GridItem md={4} sm={10} xs={12}>
        <p style={{marginBottom:"1px"}}>Name:</p>
        <TextField variant="outlined"/>
        
        
        {/* <FormControl  variant="outlined" className={classes.formControl}>
          <InputLabel id="demo-simple-select-outlined-label">USDT</InputLabel>
            <Select style={{marginBottom:"10px", width:"350px",height:"40px"}}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              // value={age}
              // onChange={handleChange}
              label="Market"
            >
              <MenuItem value="">
                <em>asd</em>
              </MenuItem>
              <MenuItem value={10}>BTC</MenuItem>
              <MenuItem value={20}>ETH</MenuItem>
              <MenuItem value={30}>GBP</MenuItem>
            </Select>
          </FormControl> */}
        </GridItem>

        <GridItem id="apiboxtextkey" md={4} sm={10} xs={12}>
        <p style={{marginBottom:"1px"}}>API Key:</p>
        <TextField md={12} sm={12} xs={12} variant="outlined"/>
        {/* <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel  id="demo-simple-select-outlined-label">Trading Pair</InputLabel>
            <Select style={{marginBottom:"10px", width:"350px",height:"40px"}}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              // value={age}
              // onChange={handleChange}
              label="Age"
            >
              <MenuItem value="">
                <em>Trading Pair</em>
              </MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </FormControl> */}
        </GridItem>

        <GridItem md={12} sm={12} xs={12} style={{}}>
        <p style={{marginBottom:"1px"}}> API Secret:</p>
        <TextField id="apisecretmyexchanges" variant="outlined"/>
        </GridItem>

        <GridItem id="apikeybutton" >
          <Button style={{background:"#00acc1"}}>Connect to a Exchange</Button>
        </GridItem>

        {/* <GridItem md={4}>
        <p style={{marginBottom:"1px"}}>Market</p>
        <FormControl  variant="outlined" className={classes.formControl}>
          <InputLabel id="demo-simple-select-outlined-label">USDT</InputLabel>
            <Select style={{marginBottom:"10px", width:"300px",}}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              // value={age}
              // onChange={handleChange}
              label="Market"
            >
              <MenuItem value="">
                <em>asd</em>
              </MenuItem>
              <MenuItem value={10}>BTC</MenuItem>
              <MenuItem onClick={ToggleFTXComponent} value={20}>ETH</MenuItem>
              <MenuItem value={30}>GBP</MenuItem>
            </Select>
          </FormControl>
        </GridItem>   */}
      </GridContainer> 
                                            {/* RightSide Information */}

        <GridContainer id="apiboxrightside" md={2} sm={12} xs={12}>
          <GridItem md={12} sm={12} xs={12}>
            <a style={{textDecoration:"none", color:"#579ee0",fontSize:"13px"}} href="#">
              <PhotoSizeSelectSmallIcon style={{width: "18px", marginRight: "10px", marginTop: "25px", marginLeft: "2px",}}/>
              {/* <AccessTime />  */}
              An overview of 3Commas
            </a>
          </GridItem>
          <GridItem md={12} sm={12} xs={12}>
            <a style={{textDecoration:"none", color:"#579ee0",fontSize:"13px"}} href="#">
              <PhotoSizeSelectSmallIcon style={{width: "18px", marginRight: "10px", marginTop: "-25px", marginLeft: "2px",}}/>
              {/* <AccessTime />  */}
              How to create an API key?
            </a>
          </GridItem>
          <GridItem md={12} sm={12} xs={12}>

            <a style={{textDecoration:"none", color:"#579ee0",fontSize:"13px"}} href="#">
              <PhotoSizeSelectSmallIcon style={{width: "18px", marginRight: "10px", marginTop: "-25px", marginLeft: "2px",}}/>
              {/* <AccessTime />  */}
              ALink a Wallet for tracking
            </a>
          </GridItem>
          <GridItem md={12} sm={12} xs={12}>

            <a style={{textDecoration:"none", color:"#579ee0",fontSize:"13px"}} href="#">
              <PhotoSizeSelectSmallIcon style={{width: "18px", marginRight: "10px", marginTop: "-25px", marginLeft: "2px",}}/>
              {/* <AccessTime />  */}
              Suggest an exchange you’d like to use
            </a>
          </GridItem>

          <GridItem md={12} sm={12} xs={12}>
            <a href="https://www.binance.com/en/futures/ref/39774710"><Button style={{ width:"230px", background:"rgb(23 22 21)"}}><img width="25" height="25"  src={Binance} alt="fireSpot"/>Sign Up at binance</Button></a>
          </GridItem>
          
          
        </GridContainer>    

      </GridContainer>
                                         

    ,false); 



    const [SupportedComponent,ToggleSupportedComponent] = ToogleThings(
      <GridItem  md={12} sm={12} xs={12}> 

        <GridContainer style={{paddingBottom:"-10px", }}>
      
          <EnhancedTable/>
      
        </GridContainer>
    
      </GridItem>
      
      ,false); 


  return (
    <div>
                                      {/* Subscription */}
      <GridContainer style={{backgroundColor:"#00acc1",borderRadius:"10px",}}>
        <GridItem xs={6} sm={6} md={6} >
        <p>2 days left in your trial period.</p>
        </GridItem>
        
        <GridItem xs={6} sm={6} md={6} style={{direction:"rtl",}} >
              <Button style={{border:"1px solid white"}} type="button" color="info">Buy Subscription</Button>
        </GridItem>
      </GridContainer>

                                        {/* Tabs */}
      <GridContainer  >

      <GridItem xs={12} sm={12} md={6} style={{marginBottom:"-2.3rem",}}>
          <CustomTabs 
            // title="Tasks:"
            headerColor="primary"
            tabs={[
              
              {
                tabName: "Dashboard",
                tabIcon: Dashboard1,
                tabPath: "/myexchanges",
                component: Typography,
                // tabContent: (
                //   <Tasks
                //     checkedIndexes={[0, 3]}
                //     tasksIndexes={[0, 1, 2, 3]}
                //     tasks={bugs}
                //   />
                // )
              },
              {
                tabName: "My Exchanges",
                tabIcon: LockIcon,
                // tabContent: (
                //   <Tasks
                //     checkedIndexes={[0]}
                //     tasksIndexes={[0, 1]}
                //     tasks={website}
                //   />
                // )
              },
              {
                tabName: "Trador's Diary",
                tabIcon: LibraryBooksIcon,
                // tabContent: (
                //   <Tasks
                //     checkedIndexes={[1]}
                //     tasksIndexes={[0, 1, 2]}
                //     tasks={server}
                //   />
                // )
              }
            ]}
          />
        </GridItem>


      </GridContainer>

                                        {/* Connect an Exchange Part */}
      <GridContainer>
        <GridItem id="ordersandpositions" md={12} sm={12} xs={12}>
                        
          <GridItem  md={12} sm={12} xs={12}> 
              
              <CardHeader style={{marginLeft:"-19px"}} color="primary" stats>
                
                <h6>Connect an exchange using an API key</h6>
  
                <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
                  <Switch onClick={ToggleOrdersComponent}/>
                </GridItem>
              </CardHeader>
              
  
              {OrdersComponent}
              
          </GridItem>
        </GridItem>
      </GridContainer>
                                                    {/* Supported Exchanges */}
      <GridItem id="ordersandpositions" md={12} sm={12} xs={12}>
                      
        <GridItem  md={12} sm={12} xs={12}> 
              
          <CardHeader style={{marginLeft:"-19px"}} color="primary" stats>
            
            <h6>Supported exchanges</h6>

            <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
              <Switch onClick={ToggleSupportedComponent}/>
            </GridItem>
          </CardHeader>

          {SupportedComponent}
          

        </GridItem>
      </GridItem>
      
    </div>
  );
}
